import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";

import {WorkerKey} from "../WorkerKey";
import {TaskModel} from "../tasks/TaskModel";
import {WorkerTeam} from "@/modules/redactor/models/worker/WorkerTeam";

export class JobConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(JobConfig, v) : SKIP;
            },
            (v) => {

                // eslint-disable-next-line
                if (v.hasOwnProperty("worker") && !v.hasOwnProperty("workers")) {
                    v.workers = [v.worker];
                }

                return deserialize(JobConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._tasks = [];
        this._teams = [];
        this._workers = [];
    }

    get tasks() {
        return this._tasks;
    }

    set tasks(value) {
        this._tasks = value;
    }

    get teams() {
        return this._teams;
    }

    set teams(value) {
        this._teams = value;
    }

    get workers() {
        return this._workers;
    }

    set workers(value) {
        this._workers = value;
    }

    valid() {
        if (this.tasks.length === 0 || this.tasks.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.teams.length === 0 && this.workers.length === 0) {
            return false;
        }

        if (this.teams.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.workers.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return this.tasks.length === 0 || (this.workers.length === 0 && this.teams.length === 0);
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new JobConfig());
        } else if (target instanceof JobConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(JobConfig, {
    _tasks: alias("tasks", list(TaskModel.schema())),
    _teams: alias("teams", list(WorkerTeam.schema())),
    _workers: alias("workers", list(WorkerKey.schema()))
});